export class Helpers {
    static showLockIcon(searchResultUrl: string, publicationsSearchResultLockIconsUrlsToExclude: string): boolean {
        //Lock icon should display for Publications page results, with the exception of pages configured in the CMS
        let showLockIcon = searchResultUrl.includes("publications.aap.org");
        if (publicationsSearchResultLockIconsUrlsToExclude && publicationsSearchResultLockIconsUrlsToExclude.length > 0) {
            let excludeList = publicationsSearchResultLockIconsUrlsToExclude.split(',').map(s => s.trim());
            let shouldExclude = excludeList.some(excludeUrl => searchResultUrl.includes(excludeUrl));
            if (shouldExclude) {
                showLockIcon = false;
            }
        }

        return showLockIcon;
    }

    static setQueryParamToUrl(queryParamKey: string, queryParamValue: string) {
        const params = new URLSearchParams(window.location.search);
        params.set(queryParamKey, queryParamValue);
        const newUrl =
            window.location.pathname +
            (params.toString() ? `?${params.toString()}` : '');
        window.history.replaceState({}, '', newUrl);
    }

    static removeQueryParamFromUrl(queryParamKey: string) {
        const params = new URLSearchParams(window.location.search);
        params.delete(queryParamKey);
        const newUrl =
            window.location.pathname +
            (params.toString() ? `?${params.toString()}` : '');
        window.history.replaceState({}, '', newUrl);
    }

    //Helper methods for SHOP Filters

    static formatFiltersForGoogleVertexAPI(filters: { [key: string]: string[] }): string {
        const filterParts = Object.entries(filters)
            .map(([attribute, values]) => this.formatFilterForGoogleVertexAPI(attribute, values))
            .filter(part => part); // Remove empty strings
        console.log(filterParts.join(" AND "))
        return filterParts.join(" AND ");

    }

    static formatFilterForGoogleVertexAPI(key: string, checkedValues: string[]) {
        if (!checkedValues.length) return '';

        const quoted = checkedValues.map(
            v => `"${v.replace(/"/g, '\\"')}"`
        );
        return `${key}: ANY(${quoted.join(',')})`;
    }

    /**
    * Parses a facets query string into a filters object
    * @param queryString A query string like "facets=Product Type:Journals & Self-Assessments,Product Type:Online Courses,attributes.aap_topics:Maintenance of Certification,attributes.aap_topics:Journals"
    * @returns An object where keys are filter names and values are arrays of selected values
    */
    static parseFacetsQueryString(queryString: string): { [key: string]: string[] } {
        const filters: { [key: string]: string[] } = {};

        // Return empty object if query string is empty
        if (!queryString) return filters;

        // Extract the facets part from the query string
        const facetsPart = queryString.startsWith('facets=')
            ? queryString.substring(7) // Remove 'facets='
            : queryString;  // Assume it's already just the facets part

        // Split by comma to get individual facet entries
        const facetEntries = facetsPart.split(',');

        // Process each facet entry
        facetEntries.forEach(entry => {
            // Split by colon to get key and value
            const [key, value] = entry.split(':').map(part => decodeURIComponent(part));

            if (key && value) {
                // Initialize the array if it doesn't exist
                if (!filters[key]) {
                    filters[key] = [];
                }

                // Add the value to the array
                filters[key].push(value);
            }
        });

        return filters;
    }

    /**
    * Creates a query string with a single facets parameter containing all filters
    * @param filters An object where keys are filter names and values are arrays of selected values
    * @returns A properly formatted query string like "Product Type:Journals & Self-Assessments,Product Type:Online Courses,attributes.aap_topics:Maintenance of Certification,attributes.aap_topics:Journals"
    */
    static createFacetsQueryString(filters: { [key: string]: string[] }): string {
        const facetValues: string[] = [];

        // Iterate through each filter
        Object.entries(filters).forEach(([key, values]) => {
            // Skip empty arrays
            if (values.length === 0) return;

            // For each value, create "key:value" format
            values.forEach(value => {
                facetValues.push(`${encodeURIComponent(key)}:${encodeURIComponent(value)}`);
            });
        });

        // If no facets, return empty string
        if (facetValues.length === 0) return "";

        // Join all facet values with commas"
        return `${facetValues.join(',')}`;
    }



    //End Helper methods for SHOP Filters
}